import moment from 'moment';
import * as timeAgo from 'timeago.js';

import { getUserInfo } from '../stores/auth';
import { client } from 'root/api/index.js';

export const BASE_URL = `${window.location.protocol}//${window.location.hostname}/`;

export const getURLParameters = (urlParam) =>
  Object.fromEntries(new URLSearchParams(urlParam || window.location.search).entries());

export const clearUrlParams = () =>
  window.history.replaceState({}, document.title, window.location.pathname);

export const sleep = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export const configItem = {
  defaultTimezone: 'UTC',
  defaultFormatId: 2,
  baseUrl: BASE_URL + 'api',
  datePickerFormat: 'd/m/Y',
  dateTimePickerFormat: 'd/m/Y H:i',
  dateDisplayFormat: 'DD/MM/YYYY',
  momentDateFormatDB: 'YYYY-MM-DD',
  taskSampleFileName: 'task-template-import-sample.csv',
  schedulerLicenseKey: process.env.FULL_CALENDAR_LICENCE_KEY,
  taskTabIndex: {
    outlook: 2,
  },
  commonStatus: [
    { id: 1, name: 'Open', checkboxKey: 1 },
    { id: 2, name: 'Complete', checkboxKey: 2 },
  ],
  allTaskStatus: [
    { id: 3, name: 'Scheduled', checkboxKey: 3 },
    { id: 1, name: 'Open', checkboxKey: 1 },
    { id: 4, name: 'Preparing', checkboxKey: 4 },
    { id: 5, name: 'In Process', checkboxKey: 5 },
    { id: 6, name: 'IQEQ Draft', checkboxKey: 6 },
    { id: 7, name: 'Client Draft', checkboxKey: 7 },
    { id: 8, name: 'IQEQ Revisions', checkboxKey: 8 },
    { id: 9, name: 'Client Revisions', checkboxKey: 9 },
    { id: 10, name: 'IQEQ Finals', checkboxKey: 10 },
    { id: 11, name: 'Client Finals', checkboxKey: 11 },
    { id: 12, name: 'IQEQ Approvals', checkboxKey: 12 },
    { id: 13, name: 'Client Approvals', checkboxKey: 13 },
    { id: 14, name: 'Waiting on Client', checkboxKey: 14 },
    { id: 2, name: 'Complete', checkboxKey: 2 },
  ],
  allComplianceStatus: [
    { id: 1, name: 'N/A', checkboxKey: 1 },
    { id: 2, name: 'Pending', checkboxKey: 2 },
    { id: 3, name: 'Within Compliance', checkboxKey: 3 },
    { id: 4, name: 'Out of Compliance', checkboxKey: 4 },
    { id: 5, name: 'Action Required', checkboxKey: 5 },
    { id: 6, name: 'Decision Needed', checkboxKey: 6 },
    { id: 7, name: 'Resolved', checkboxKey: 7 },
  ],
  maxLength: {
    input: 150,
    textarea: 250,
    body: 10000,
    masterInput: 150,
    description: 500,
  },
  status: {
    inactive: 0,
    active: 1,
  },
  roleIndex: {
    admin: 1,
    unit_admin: 2,
    manager: 3,
    user: 4,
  },
  roleLabel: {
    1: 'Super Admin',
    2: 'Unit Admin',
    3: 'Manager',
    4: 'User',
  },
  priority: [
    { id: 1, name: 'Low', icon: 'priority-lowest.png', extraClass: 'text-dark' },
    { id: 2, name: 'Normal', icon: 'priority-medium.png', extraClass: 'text-dark' },
    { id: 3, name: 'High', icon: 'priority-highest.png', extraClass: 'high-priority' },
  ],
  // Risk Rank for Task Library / Task Dashboard
  riskRank: [
    { id: 1, name: 'Low', icon: 'priority-lowest.png', extraClass: '' },
    { id: 2, name: 'Medium', icon: 'priority-medium.png', extraClass: '' },
    { id: 3, name: 'High', icon: 'priority-highest.png', extraClass: 'high-risk-rank' },
  ],
  assignTypes: [
    {
      checked: true,
      label: 'Only change it here.',
      value: 1,
    },
    {
      checked: false,
      label: 'Change any Open instances of the task and its linked Scheduled task(s).',
      value: 2,
    },
  ],
  deleteAssignTypes: [
    {
      checked: true,
      label: 'Only delete it here.',
      value: 1,
    },
    {
      checked: false,
      label: 'Delete any Open instances of the task and its linked Scheduled task(s)',
      value: 2,
    },
  ],
  recurringTypes: [
    { id: 1, name: 'Daily' },
    { id: 2, name: 'Weekly' },
    { id: 3, name: 'Monthly' },
    { id: 4, name: 'Quarterly' },
    { id: 5, name: 'Annually' },
  ],
  customRecurringTypes: [
    { id: 1, name: 'Days' },
    { id: 2, name: 'Weeks' },
    { id: 3, name: 'Months' },
    { id: 4, name: 'Quarters' },
    { id: 5, name: 'Years' },
  ],
  service_provider_other_prefix: 'Other –',
  passwordValidation: {
    expression: /(?=.*[A-Za-z0-9])(?=.*[@$!%*#?&])/,
    message: 'Alphanumeric with one special character',
    note: 'Alphanumeric with one special character',
  },
};

export const openStatusId = configItem?.allTaskStatus
  .filter((element) => !['Scheduled', 'Complete'].includes(element.name))
  ?.map((item) => item.id);

export function itemIndexOf(items, value, prop = 'id') {
  if (items == undefined || items.length == 0) return -1;
  const indexOfVal = (item) => item[prop] == value;
  return items.findIndex(indexOfVal);
}

export const customInputEvent = (name, value) => {
  return {
    target: {
      name,
      value,
    },
  };
};

export const getTodayDate = () => {
  return moment().format('YYYY-MM-DD');
};

export const getTime = (flag) => {
  // moment.tz.setDefault(configItem.defaultTimezone);
  if (flag == 'calender') {
    return moment().format(configItem.momentCalenderDateFormatDB);
  }
  if (flag == 'calenderTime') {
    return moment().format(configItem.momentCalenderTimeFormatDB);
  }
  if (flag == 'now') {
    return moment().format('HH') + ':' + moment().format('mm');
  }
  return (
    moment().format('HH') +
    ':' +
    (moment().format('mm') - (moment().format('mm') % configItem.minuteInterval))
      .toString()
      .padStart(2, 0)
  );
};

export const searchKeyByValue = (
  searchItems,
  searchKey,
  searchValue,
  otherSearchKey,
  otherSearchValue,
) => {
  return searchItems.findIndex((item) => {
    if (otherSearchKey != undefined) {
      return item[searchKey] == searchValue && item[otherSearchKey] == otherSearchValue;
    }
    return item[searchKey] == searchValue;
  });
};

export const mergeOutlookArr = (old, newd) => {
  let oldOutlookData = JSON.parse(JSON.stringify(old));
  let newOutlookData = JSON.parse(JSON.stringify(newd));
  for (var outerKey in newOutlookData) {
    let outerLabelKey = searchKeyByValue(oldOutlookData, 'label', newOutlookData[0].label);
    if (outerLabelKey == -1) {
      oldOutlookData.push(newOutlookData[outerKey]);
    } else {
      for (var innerKey in newOutlookData[outerKey].data) {
        let labelKey = searchKeyByValue(
          oldOutlookData[outerLabelKey].data,
          'label',
          newOutlookData[outerKey].data[innerKey].label,
        );
        if (labelKey == -1) {
          oldOutlookData[outerLabelKey].data.push(newOutlookData[outerKey].data[innerKey]);
        } else {
          oldOutlookData[outerLabelKey].data[labelKey].data = oldOutlookData[outerLabelKey].data[
            labelKey
          ].data.concat(newOutlookData[outerKey].data[innerKey].data);
          oldOutlookData[outerLabelKey].data[labelKey].completeCount +=
            newOutlookData[outerKey].data[innerKey].completeCount;
          oldOutlookData[outerLabelKey].data[labelKey].pendingCount +=
            newOutlookData[outerKey].data[innerKey].pendingCount;
          oldOutlookData[outerLabelKey].data[labelKey].overdueCount +=
            newOutlookData[outerKey].data[innerKey].overdueCount;
        }
      }
    }
  }
  return oldOutlookData;
};

export const mergeNotificationArr = (old, newd) => {
  let oldData = JSON.parse(JSON.stringify(old));
  let newData = JSON.parse(JSON.stringify(newd));
  for (var outerKey in newData) {
    if (newData[outerKey].label != '') {
      let outerLabelKey = searchKeyByValue(oldData, 'label', newData[outerKey].label);
      if (outerLabelKey == -1) {
        oldData.push(newData[outerKey]);
      } else {
        newData[outerKey].values.map((item) => {
          oldData[outerLabelKey].values.push(item);
        });
      }
    }
  }
  return oldData;
};

let textFile = null;
const makeTextFile = (text) => {
  var BOM = new Uint8Array([0xef, 0xbb, 0xbf]);
  var data = new Blob([BOM, text], { type: 'text/csv' });
  if (textFile !== null) {
    window.URL.revokeObjectURL(textFile);
  }
  textFile = window.URL.createObjectURL(data);
  return textFile;
};

export const downloadFile = async (blob, fileName) => {
  const downloadUrl = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', downloadUrl);
  link.setAttribute('download', fileName);
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  window.URL.revokeObjectURL(link.href);
  document.body.removeChild(link);
};

export const downloadCsvFile = async (data, fileName) => {
  var csvContent = await data.text();
  var link = document.createElement('a');
  link.setAttribute('href', makeTextFile(csvContent));
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
};

export const downloadUrlFile = (fileUrl, fileName) => {
  var link = document.createElement('a');
  link.setAttribute('href', fileUrl);
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
};

export const startMonthDateFormat = (date) => {
  return moment(date).format('D') == 1
    ? moment(date).format(configItem.momentDateFormatDB)
    : moment(date).add(1, 'months').startOf('month').format(configItem.momentDateFormatDB);
};

export const dbDateFormat = (date) => {
  return moment(date).format(configItem.momentDateFormatDB);
};
export const showNumberFormat = (number) => {
  return number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';
};
export const displayTimeAgo = (date) => {
  if (date == undefined || date == null || date.toString().trim() == '' || date == 0) {
    return '';
  }
  // var date=moment.tz("2021-03-05 10:50:00").utcOffset('+05:30');
  //return date;
  return timeAgo.format(new Date(date));
};
export const mintChangeSec = (minutes) => {
  return minutes * 60 * 1000; //change mint to milli sec
};

export const setYupMessage = (yup) => {
  yup.setLocale({
    mixed: {
      required: 'Required',
      notType: function notType(_ref) {
        switch (_ref.type) {
          case 'number':
            return 'Enter numbers only';
          case 'string':
            return 'Required field';
        }
      },
    },
    string: {
      email: 'Invalid Email',
      url: 'Invalid Url',
    },
    number: {
      min: 'Min: ${min}',
      max: 'Max: ${max}',
      integer: 'Whole number only',
    },
  });
};

export const getHashUrlParam = () => {
  var hash = window.location.hash.substr(1);
  var result = hash.split('&').reduce(function (res, item) {
    var parts = item.split('=');
    res[parts[0]] = parts[1];
    return res;
  }, {});
  return result;
};

import * as yup from 'yup';

export async function validateData(data, validationSchema) {
  try {
    await validationSchema.validate(data);
    return true;
  } catch (error) {
    return false;
  }
}

export function validURL(str) {
  const validationSchema = yup.object().shape({
    url: yup.string().url(),
  });
  const data = {
    url: addHttpIfNot(str),
  };
  try {
    validationSchema.validateSync(data, { abortEarly: false });
    return true;
  } catch (error) {
    return false;
  }

  return validateData(userData, userSchema);
  let expression =
    /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi;
  let regex = new RegExp(expression);
  return str.match(regex);
  const urlRegExp = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?(@[\da-z\.-]+)?$/;
  return urlRegExp.test(str);

  var pattern = new RegExp(
    '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ); // fragment locator
  var pattern = new RegExp("^((https?://)?([-%()_.!~*';/?:@&=+$,A-Za-z0-9])+)$", 'i');
  var pattern = new RegExp("^((https?://)?([-%()_.!~*';/?:@&=+$,A-Za-z0-9])+)$", 'i');
  return !!pattern.test(str);
}

export const addHttpIfNot = (s) => {
  if (!s.match(/^[a-zA-Z]+:\/\//)) {
    s = 'http://' + s;
  }
  return s;
};

export const numberOnly = (evt) => {
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (charCode < 48 || charCode > 57) {
    evt.preventDefault();
    return false;
  }
  return true;
};

export const cloneArray = (arr) => {
  return JSON.parse(JSON.stringify(arr));
};
export const compareArray = (object1, object2) => {
  return JSON.stringify(object1) === JSON.stringify(object2);
};
export const replaceAt = (str, index, replacement) => {
  return str.substr(0, index) + replacement + str.substr(index + replacement.length);
};

export const downloadUrl = (downloadUrl) => {
  const link = document.createElement('a');
  link.href = downloadUrl;
  link.click();
};

export const autogrowTextarea = (el, minHeight) => {
  minHeight = minHeight != undefined ? minHeight : 30;
  if (el.clientHeight < el.scrollHeight) {
    el.style.height = el.scrollHeight + 'px';
  } else {
    el.style.height = minHeight + 'px';
  }
};

export const transform = (value) => {
  if (value === '') {
    return null;
  } else if (value === '*') {
    return null;
  } else {
    return value;
  }
};

export const emptyStringToNull = (value, originalValue) => {
  if (typeof originalValue === 'string' && originalValue === '') {
    return null;
  }
  return value;
};

export const removeAllTooltip = (e) => {
  document.querySelectorAll('.popover.show').forEach((el) => el.remove());
};

export const getValueBySearchValue = (
  searchItems,
  searchKey,
  searchValue,
  responseKey,
  defaultResponse,
) => {
  let searchIndex = searchItems.findIndex((item) => {
    return item[searchKey] == searchValue;
  });
  return searchIndex != -1
    ? searchItems[searchIndex][responseKey]
    : defaultResponse
      ? defaultResponse
      : '';
};

export const userDateFormat = (date) => {
  return moment(date).format(getUserInfo().datePickerMomentJsFormat);
};
export const isPastDate = (date) => {
  return moment(date).isBefore(moment().format(configItem.momentDateFormatDB));
};

export const isValidUrl = (urlString) => {
  var urlPattern = new RegExp(
    '^(https?:\\/\\/)?' + // validate protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // validate domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // validate OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // validate port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // validate query string
      '(\\#[-a-z\\d_]*)?$',
    'i',
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};

export const createLinkIfValidUrl = (urlString) => {
  if (isValidUrl(urlString)) {
    return "<a href='" + urlString + "' target='_blank'>" + urlString + '</a>';
  }
  return urlString;
};

export const fileDownload = async (fileId, fileName) => {
  try {
    const response = await client.fileDownloadUrl({ fileId });

    const responseBlob = await response.blob();
    const blobUrl = window.URL.createObjectURL(responseBlob);
    const link = document.createElement('a');

    link.href = blobUrl;
    if (fileName) link.download = fileName;
    document.body.appendChild(link);

    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch {
    return null;
  }
};

// URL parameter validations
const regexValidFormatDate = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;

const validIdNumber = (number) => {
  return (
    typeof number === 'number' &&
    !isNaN(number) &&
    Number.isInteger(number) &&
    Number.isFinite(number) &&
    number > 0
  );
};

const isValidStringDate = (dateString) => {
  const date = new Date(dateString);
  const [year, month, day] = dateString?.split('-').map((item) => Number(item));
  return (
    !isNaN(date.getTime()) &&
    date.getUTCFullYear() === year &&
    date.getUTCMonth() + 1 === month &&
    date.getUTCDate() === day
  );
};

const dateChecker = (start_date, end_date) => {
  const formatStartDate = start_date?.replaceAll('/', '-');
  const formatEndDate = end_date?.replaceAll('/', '-');
  const startDate = new Date(formatStartDate);
  const endDate = new Date(formatEndDate);
  return (
    regexValidFormatDate.test(formatStartDate) &&
    regexValidFormatDate.test(formatEndDate) &&
    isValidStringDate(formatStartDate) &&
    isValidStringDate(formatEndDate) &&
    startDate <= endDate
  );
};

// Function to get string id list and check if is a valid ID number.
const listIdChecker = (stringList, key, idKey = 'id') => {
  if (!stringList || !key) return null;
  const idListNumbers = stringList.split(',').map((id) => Number(id)) || [];
  const checkValidIdNumbers = idListNumbers.filter((item) => validIdNumber(item));
  if (!checkValidIdNumbers?.length) return null;
  return {
    [key]: checkValidIdNumbers.map((item) => ({ [idKey]: item })),
  };
};

// Function to get string id list of specific configuration check if is a valid ID from that list.
const configIdChecker = (stringList, configKey, key, idKey = 'id') => {
  if (!stringList || !configKey || !key) return null;
  const isListNumbers = stringList.split(',').map((cv) => Number(cv));
  const checkValidIdNumbers = configItem[configKey]?.filter?.((obj) =>
    isListNumbers.includes(obj.id),
  );
  if (!checkValidIdNumbers?.length) return null;
  return {
    [key]: checkValidIdNumbers.map((ele) => ({
      ...ele,
      [idKey]: ele.id,
    })),
  };
};

const urlParameterSchema = {
  due_from_date: ({ due_from_date, due_to_date }) => {
    if (!dateChecker(due_from_date, due_to_date)) return null;
    return { fromDate: due_from_date.replaceAll('/', '-') };
  },
  due_to_date: ({ due_from_date, due_to_date } = {}) => {
    if (!dateChecker(due_from_date, due_to_date)) return null;
    return { toDate: due_to_date.replaceAll('/', '-') };
  },
  initial_board_from_date: ({ initial_board_from_date, initial_board_to_date }) => {
    if (!dateChecker(initial_board_from_date, initial_board_to_date)) return null;
    return { initialFromDate: initial_board_from_date.replaceAll('/', '-') };
  },
  initial_board_to_date: ({ initial_board_from_date, initial_board_to_date }) => {
    if (!dateChecker(initial_board_from_date, initial_board_to_date)) return null;
    return { initialToDate: initial_board_to_date.replaceAll('/', '-') };
  },
  service_type: ({ service_type }) => listIdChecker(service_type, 'taskServiceType'),
  activity_type: ({ activity_type }) => listIdChecker(activity_type, 'taskActivityTypes'),
  priority: ({ priority }) => configIdChecker(priority, 'priority', 'priority'),
  compliance_status: ({ compliance_status }) =>
    configIdChecker(compliance_status, 'allComplianceStatus', 'taskComplianceStatusType'),
  risk_rank: ({ risk_rank }) => configIdChecker(risk_rank, 'riskRank', 'taskRiskRankType'),
  task_category: ({ task_category }) =>
    configIdChecker(task_category, 'allTaskStatus', 'task_category'),
  status: ({ status }) => {
    const result = configIdChecker(status, 'commonStatus', 'status');
    const [mainStatus] = result?.status || [];
    if (!mainStatus?.id) return null;
    return {
      status: mainStatus?.id,
    };
  },
};

// Function to get parameters from URL and validate the values according with the URL schema and parse into an Object.
export const getUrlFilters = () => {
  const allUrlparams = getURLParameters();
  return Object.keys(allUrlparams).reduce((acc, val) => {
    const getValues = urlParameterSchema[val]?.(allUrlparams) || {};
    return {
      ...acc,
      ...getValues,
    };
  }, {});
};
